import { createResponseSchema } from '@mint-sdk/api-core';
import { z } from 'zod';

export const AdformLandingPageSchema = z.object({
  id: z.string(),
  name: z.string(),
});

export const AdformCampaignLandingPagesSchema = z.object({
  id: z.string(),
  name: z.string(),
  landingPages: z.array(AdformLandingPageSchema),
});

export const AdformLandingPagesResponseSchema = createResponseSchema(
  AdformCampaignLandingPagesSchema,
);

export type AdformLandingPageType = z.infer<typeof AdformLandingPageSchema>;
export type AdformCampaignLandingPagesType = z.infer<
  typeof AdformCampaignLandingPagesSchema
>;
export type AdformLandingPagesResponseType = z.infer<
  typeof AdformLandingPagesResponseSchema
>;
